import TYPES from './types';

//sets the client side checkbox options
export const setUnderwriterVerifiedRule = (FEVerified) => ({
  type: TYPES.SET_FE_VERIFIED,
  payload: FEVerified,
});
